import axios from 'axios';
import config from 'api/urls-config.json';
import { API } from 'api/constants';

export const getHomepage = () => {
    return axios.get(API + config.pages.homepage);
};
